import { useMyRolePrivilegeQuery } from '@/types/generated/graphql';
import { COOKIE_KEY } from '@shared/constants';
import { rolePrivilegeStore } from '@shared/store/role-privilege.store';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

export const useInitRolePrivilege = () => {
  const authorization = Cookies.get(COOKIE_KEY.accessToken) ?? '';
  const workspaceSecret = Cookies.get(COOKIE_KEY.workspaceSecret) ?? '';

  const { data, error, loading } = useMyRolePrivilegeQuery({
    skip: !authorization || !workspaceSecret, // skip when there is no authorization or workspace secret
  });
  const { rolePrivileges, updateRolePrivileges } = rolePrivilegeStore();

  const userRoles = data?.myRolePrivilege?.edges || [];
  const userPermissions = userRoles?.map(
    (perms) => `${perms?.screen?.slug}.${perms?.module?.slug}.${perms?.privilege?.slug}`
  );

  // using object for quick search operation - O(1)
  const permissionsObj: Record<string, boolean> = {};
  for (const userPermission of userPermissions) {
    permissionsObj[userPermission] = true;
  }

  useEffect(
    function updateRolePrivilegesInStore() {
      if (userPermissions && !error && !loading) {
        updateRolePrivileges(permissionsObj);
      } else if (!loading || error) updateRolePrivileges({});
    },
    [loading, error, data]
  );

  return { fetchingRolePrivileges: loading || !rolePrivileges };
};
